<template>
  <div class="account-set">
    <!-- <img class="banner" src="@/assets/images/banner.png" /> -->
    <div class="banner">
      <div class="text-box">
        <div class="title">{{type == 1 ? '提现': '入网签约'}}账户管理</div>
        <div class="title-mini">设置绑定{{type == 1 ? '提现': '入网签约'}}人</div>
      </div>
    </div>
    <div class="content-box">
      <van-search 
        class="search" 
        v-model="value" 
        placeholder="请输入要绑定的职员姓名或手机号"
        @clear="clearValue" 
        @input="search"
      >
        <div class="label-box" slot="label" >
          <template v-if="!isDisabled">
            <div 
              class="label-left" 
              v-for="(item,index) in currentAccount" 
              :key="index"
              @click="delAccount(item,index)"
            >
              <span>{{item.userName}}</span>
              <span>{{item.telephone}}</span>
            </div>
          </template>
        </div>
      </van-search>
      <div class="content">
        <div class="list" v-for="(item,index) in list" :key="index" @click="chooseAccount(item,index)">
          <div class="list-left" :class="{'active': item.isCheck}"></div>
          <div class="list-right">
            <div class="name">({{item.account}}){{item.userName}}</div>
            <div class="number">{{item.telephone}}</div>
          </div>
        </div>
      </div>
      <div class="tips" v-if="!list.length && isFirst">
        没有搜索到相关信息，请重新搜索
        <van-icon name="search" size="18" />
        
      </div>
      <div style="height: 84px;"></div>
    </div>
    <div class="footer">
      <van-button
        plain 
        class="botton-left"
        type="primary"
        @click="cancel"
      >
        取消
      </van-button>
      <van-button  
        class="botton" 
        color="#FF6B59"
        :disabled="isDisabled"
        @click="confirm"
      >
        确定
      </van-button>
    </div>
    <bingding-pop 
      v-if="isBindingPop"
      :isBindingPop.sync="isBindingPop" 
      :currentAccount="currentAccount"
      :phoneNumber="phoneNumber"
    />
  </div>
</template>

<script>
import bingdingPop from './components/binding-pop'
import _ from 'loadsh'
export default {
  components: {
    bingdingPop
  },
  computed: {
    isDisabled() {
      return this.currentAccount.length ? false : true
    },
    type() {
      return this.$route.query.type
    }
  },
  data() {
    return {
      value: '',
      list: [],
      currentAccount: [],
      isBindingPop: false,
      phoneNumber: '',
      checkbox: false,
      isFirst: false,
      debounceFn: _.debounce(this.querySearchStaffList,500)
    }
  },
  mounted() {
    this.getBindingInfo()
    this.getCheckbox()
  },
  methods: {
    search() {
      this.debounceFn()
    },
    // 获取经销商信息
    getBindingInfo() {
      this.$api.withdrawal.getBindingInfo()
        .then(res => {
          if (res.data) {
            this.phoneNumber = res.data.phone
          }
        })
    },
    // 查询是否为多选
    getCheckbox() {
      this.$api.h5.queryPublicityData('h5_withdraw_binding')
        .then(res => {
          this.checkbox = JSON.parse(res.data.checkbox)
        })
    },
    querySearchStaffList() {
      let parames = {
        filterData: {
          word: this.value,
          type: this.type,
        },
        pageNum: 1,
        pageSize: 10000
      }
      this.$api.withdrawal.querySearchStaffList(parames)
        .then(res => {
          this.list = res.data.list
          if (this.currentAccount.length && this.list.length) {
            this.initState(this.list)
          }
          this.isFirst = true
        })
    },
    chooseAccount(item) {
      // 多选
      if (this.checkbox) {
        item.isCheck = !item.isCheck
        let sub = this.currentAccount.findIndex(obj => obj.account == item.account)
        if (sub == -1) {
          this.currentAccount.push(item)
        }else {
          this.currentAccount.splice(sub,1)
        }
        // 单选
      }else {
        if (this.currentAccount.length) {
          this.currentAccount[0].isCheck = false
        }
        item.isCheck = true
        this.currentAccount = [item]
      }
    },
    initState(list) {
      this.currentAccount.forEach(item => {
        for(let i=0; i < list.length; i++) {
          if (item.account == list[i].account) {
            this.list[i].isCheck = true
            break
          }
        }
      })
    },
    clearValue() {
      this.value = ''
    },
    delAccount(item,index) {
      if (this.list.length) {
        let sub = this.list.findIndex( obj => obj.account == item.account)
        if (sub != -1) this.list[sub].isCheck = false
      }
      this.currentAccount.splice(index,1)
    },
    cancel() {
      this.$router.go(-1)
    },
    confirm() {
      this.isBindingPop = true
    }
  }
}
</script>

<style lang="stylus" scoped>
  .account-set {
    .banner {
      width: 100%;
      height: 170px;
      color: #fff;
      background: url('https://img3.quanyou.com.cn/joyNew/group1/M00/32/E7/rB8LrWXxXwiAEJ7CAADax5jHRek191.png');
      background-size: 100% 100%;
      overflow: hidden;
      .text-box {
        margin: 36px 0 0 25px;
        .title {
          color: #fff;
          font-size: 28px;
          font-weight: bold;
        }
        .title-mini {
          font-size: 15px;
          margin-top: 6px;
        }
      }
    }
    .content-box {
      position: absolute;
      top: 190px;
      width: 100%;
      padding: 20px;
      background: #F4F4F4;
      box-sizing: border-box;
      border-radius: 17px 17px 0px 0px;
      .search {
        margin-bottom: 10px;
        .van-search__content {
          background: #fff;
        }
        padding: 0;
        .label-box {
          display: flex;
          height: 100%;
          max-width: 180px;
          overflow-y: auto;
          margin-left: -14px;
          .label-left {
            display: flex;
            flex-direction: column;
            align-items: center;
            flex-grow: 0;
            flex-shrink: 0;
            width: 100px;
            height: 100%;
            margin-right: 4px;
            padding: 4px 0;
            background: rgba(255, 136, 32,1);
            color: #fff;
            line-height: 18px;
            border-radius: 6px; 
            box-sizing: border-box;
          }
          .label-left:first-child {
            margin-left: 4px;
          }
        }
        
        /deep/ .van-field__control{
          height: 36px;
        }
        /deep/ .van-icon-search {
          line-height: 36px;
        }
        /deep/ .van-cell {
          transition: 10s ease all;
        }
      }
      .content {
        height: 100%;
        .list {
          display: flex;
          align-items: center;
          width: 100%;
          padding: 15px;
          background: #fff;
          box-sizing: border-box;
          margin-bottom: 10px;
          border-radius: 8px;
          .list-left{
            display: flex;
            align-items: center;
            justify-content: center;
            width: 14px;
            height: 14px;
            border: 1px solid #ccc;
            border-radius: 50%;
            margin-right: 20px;
          }
          .active {
            border: 1px solid #FF6B31;
          }
          .active::before {
            content: "";
            display: inline-block;
            width: 7px;
            height: 7px;
            border: 1px solid #FF6B31;
            border-radius: 50%;
            background: #FF6B31;
            margin-right: 0.5px;
          }
          .list-right {
            width: 270px;
            word-wrap: break-word;
            .name {
              color: #333333;
              font-size: 15px;
              margin-bottom: 4px;
              font-weight: 400;
            }
          } 
        }
      }
      .tips {
        display: flex;
        justify-content: center;
        color #777
        font-size 12px
        text-align: center;
        margin-top: 100px;
      }
    }
    .footer {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      display: flex;
      justify-content space-around;
      height: 84px;
      background: #fff;
      .botton {
        width: 138px;
        margin-top: 10px;
        border-radius: 8px;
      }
      .botton-left {
        width: 138px;
        color: #FF6B31;
        border: 1px solid #FF6B59;
        margin-top: 10px;
        border-radius: 8px;
      }
    }
  }
</style>